import { render, staticRenderFns } from "./RegistrarNuevaRemesaDialogComponent.vue?vue&type=template&id=fcf2bfec&scoped=true"
import script from "./RegistrarNuevaRemesaDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistrarNuevaRemesaDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./RegistrarNuevaRemesaDialogComponent.vue?vue&type=style&index=0&id=fcf2bfec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf2bfec",
  null
  
)

export default component.exports